import { Component, OnDestroy, OnInit } from '@angular/core';

import { AppUtilityService } from './../../core/services/app-utility.service';
import { ConfigService } from './../../core/services/config.service';
import { EditModeService } from '../../core/services/edit-mode.service';
import { LmsBaseAppComponent } from './../../core/component/base-app/lms-base-app.component';
import { LmsMenuService } from './../../core/services/lms-menu.service';
import { LmsModuleService } from './../../core/services/lms-module.service';
import { OutlyingPoint } from './../../core/model/outlying-point.model';
import { OutlyingPointService } from './../services/outlying-point-service';
import { PopupService } from '../../core/services/popup.service';
import { RouteChangePopupService } from './../../core/services/route-change-popup.service';
import { UtilService } from './../../core/services/util.service';
import { PermitAll } from '@csx/security';

/**
 * @export
 * @class OutlyingPointDataComponent
 * @extends {LmsBaseAppComponent}
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-outlying-point-data',
  templateUrl: './outlying-point-data.component.html',
  styleUrls: ['./outlying-point-data.component.scss']
})
@PermitAll()
export class OutlyingPointDataComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {

  oulyingDataDisplay: Array<OutlyingPoint>; // Display List which is used to Display
  configData: any; // Get Labels from Config Service

  /**
   * Creates an instance of OutlyingPointDataComponent.
   * @param {OutlyingPointService} outlyingPointService
   * @param {ConfigService} configService
   * @param {LmsMenuService} lmsMenuService
   * @param {LmsModuleService} lmsModuleService
   * @param {UtilService} utilService
   * @param {EditModeService} editModeService
   * @param {RouteChangePopupService} routerChangePopUpService
   * @param {PopupService} popupService
   * @param {AppUtilityService} appUtilityService
   * @memberof OutlyingPointDataComponent
   */
  constructor(private outlyingPointService: OutlyingPointService, configService: ConfigService,
    lmsMenuService: LmsMenuService,
    lmsModuleService: LmsModuleService,
    utilService: UtilService,
    editModeService: EditModeService,
    routerChangePopUpService: RouteChangePopupService,
    popupService: PopupService, private appUtilityService: AppUtilityService) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routerChangePopUpService, popupService);
    this.service = this.outlyingPointService;
    this.type = this.configService.getConfigData().menu.type.outlyingPoints;
    this.configData = this.configService.getConfigData();
    this.outlyingPointService.loadData.subscribe(data => {
      setTimeout(() => {
        if (this.selectedTab) {
          this.selectedTab.description = this.appUtilityService.showDeskName(this.selectedTab) ? this.appUtilityService.showDeskName(this.selectedTab) : this.configData.tab.defaultDescription;
          this.updateTab(this.selectedTab);
        }
      });
    });
  }

  ngOnInit() {
    super.init(this.search);
  }

  ngOnDestroy() {
    super.destroy();
  }

  /**
   * This is search method
   * @memberof OutlyingPointDataComponent
   */
  public search() {
    this.outlyingPointService.load(this.selectedTab);
  }

  /**
   * This method clears error message
   * @param {any} event
   * @memberof OutlyingPointDataComponent
   */
  public clearErrorMessage(event) {
    this.selectedTab.subTypeDetail.data.message = this.configData.outlyingPointLabel.blank;
    this.lmsModuleService.updateSelectedTab(this.selectedTab);
  }

  /**
   * This method sets the list according to filter and pass the same to child
   * @param {any} event
   * @memberof OutlyingPointDataComponent
   */
  updatedOutlyingDisplayList(event) {
    if (event) {
      this.oulyingDataDisplay = event;
    }
  }
}
